<template>
  <van-popup v-model="show" :overlay=false :style="{ width: '100%', height: '100vh' }">
    <div class="popup-tx">
      <div class="pc-title-border pc-title pc-title1">
        <p class="icon">
          <i @click="qrClone" class="el-icon-close"></i>
        </p>
        <span>自动交易</span>
      </div>

      <div class="tx-con">
        <!--步骤条-->
<!--        <el-steps :active="activeStep">-->
<!--          <el-step title="买入" icon="el-icon-edit"></el-step>-->
<!--          <el-step title="卖出" icon="el-icon-upload"></el-step>-->
<!--        </el-steps>-->

        <StepBar :status="activeStep"/>

        <walletCard :selectedList="selectedList" :defaultPath="defaultPath"
                    :balance="balance"
                    :allJs="allJs"
                    :transactionType="transactionType"
                    :todayVol="todayVol"
                    :todayTradeList="todayTradeList"
                    :tradeAmount="tradeAmount"
                    :firstCalculatedValue="firstCalculatedValue"
                    :secondCalculatedValue="secondCalculatedValue"></walletCard>

        <div class="transaction-summary1">
          <p class="summary-title">今日交易详情</p>
          <div @click="showTransactionDetails = true">
            <span>查看更多</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
        <!-- 交易记录列表 -->
        <transaction-list :transactions="todayTradeList"></transaction-list>

        <div>

        </div>
      </div>
      <div class="chain-confirm">
        <div class="progress-container">
          <div class="progress-bar">
            <span :style="{ width: progressPercentage + '%' }"></span>
          </div>
          <div class="progress-text">
            <p>当前自动交易次数: {{ currentNum }}</p>
            <p>总交易次数{{ localTranNum }}次</p>
          </div>
        </div>
        <div class="btn-p">
          <div class="ty-button ty-button1" @click="qrClone">退出</div>
          <!--          开启自动交易-->
          <div class="ty-button" @click="clickTxsPar()" v-if="isStart == 0">开启自动交易</div>
          <div class="ty-button" style="display: flex;align-items: center;justify-content: center" v-else-if="isStart == 1">
            <van-loading size="17px" type="spinner" />
             &nbsp;正在交易
          </div>
          <div class="ty-button" @click="clickTxsPar()" v-else-if="isStart == 2">继续自动交易</div>
          <div class="ty-button ty-button1" v-else-if="isStart == 3">交易已完成</div>
        </div>
      </div>

      <van-dialog v-model:show="wcShow" theme="round-button" confirm-button-color="#000" @confirm="closePopup">
        <div class="wc-dialog">
          <img  src="~@/assets/imgs/wc.png" alt="">
          <h1>恭喜你</h1>
          <h2>当前自动交易已完成</h2>
        </div>
      </van-dialog>
      <van-dialog v-model:show="balanceTipShow" theme="round-button" confirm-button-text="去充值" confirm-button-color="#000"  @confirm="showRechargePopup = true">
        <div class="wc-dialog">
          <img  src="~@/assets/imgs/jb.gif" alt="">
          <h1>Gas 余额不足</h1>
          <h2>无法继续交易，请核实后再试</h2>
        </div>
      </van-dialog>
      <!-- 充值弹窗 -->
      <recharge-popup :show.sync="showRechargePopup" @recharge="handleRecharge"></recharge-popup>
      <transaction-details :show="showTransactionDetails" :show.sync="showTransactionDetails"></transaction-details>
    </div>
  </van-popup>
</template>

<script>
import {mapState} from "vuex";
import walletCard from './../pageComponents/wallet_card'
import TransactionList from './../pageComponents/transaction_list'
import Decimal from "decimal.js";
import RechargePopup from "./recharge_popup";
import StepBar from "../../../../components/StepBar";
import TransactionDetails from "./transaction_details";
import {$formatDecimals} from "../../../../util/context";

export default {
  name: 'SignTransaction',
  props: ["show", "createInfo", "tradeAmount", "selectedList", "defaultPath", "tranNum", "defaultBalance","balance","todayVol","allJs","todayTradeList"],
  components: {
    RechargePopup,
    walletCard,
    TransactionList,
    StepBar,
    TransactionDetails
  },
  data() {
    const vm = this
    return {
      showTransactionDetails: false,
      showRechargePopup: false,
      wcShow:false, //交易完成提示
      balanceTipShow:false, //余额不足提示
      localTranNum: 0,
      activeStep: 0,
      currentNum: 0,
      transactions: [],
      isAdd: true,
      isStart: 0,//是否开始
      USDTBalance: 0,
      WBNBBalance: 0,
    };
  },
  mounted() {
    const vm = this;
    const contentContainer = document.querySelector('.tx-con');
    const yxHeader = document.querySelector('.pc-title-border'); // yx-header 组件中的 header 类

    if (contentContainer && yxHeader) {
      contentContainer.addEventListener('scroll', function() {
        if (contentContainer.scrollTop > 0) {
          yxHeader.classList.add('with-border');
        } else {
          yxHeader.classList.remove('with-border');
        }
      });
    }
  },
  computed: {
    ...mapState([
      "accountInfo",
    ]),
    transactionType() {
      return this.activeStep === 0 || this.activeStep === 1 ? 'buy' : 'sell';
    },
    // 第一个值 = tradeAmount * selectedList.price
    firstCalculatedValue() {
      if (!this.tradeAmount || !this.selectedList || !this.selectedList.price) {
        return '0';
      }
      try {
        const amount = new Decimal(this.tradeAmount);
        const price = new Decimal(this.selectedList.price);

        // 计算结果并格式化为字符串，保留2位小数
        return amount.times(price);
      } catch (error) {
        console.error('计算第一个值时出错:', error);
        return '0';
      }
    },
    // 第二个值 = 第一个值 / defaultPath.price
    secondCalculatedValue() {
      if (!this.tradeAmount || !this.selectedList || !this.selectedList.price ||
          !this.defaultPath || !this.defaultPath.price) {
        return '0';
      }

      try {
        // 使用Decimal.js进行精确计算
        const amount = new Decimal(this.tradeAmount);
        const selectedPrice = new Decimal(this.selectedList.price);
        const defaultPrice = new Decimal(this.defaultPath.price);

        // 计算第一个值
        const firstValue = amount.times(selectedPrice);

        // 计算第二个值并格式化为字符串，保留2位小数
        return firstValue.dividedBy(defaultPrice);
      } catch (error) {
        console.error('计算第二个值时出错:', error);
        return '0';
      }
    },
    progressPercentage() {
      const vm = this
      // 计算进度百分比，避免除以0的情况
      return vm.localTranNum > 0 ? (vm.currentNum / vm.localTranNum) * 100 : 0;
    },

    // 添加当前余额计算属性
    currentBalance() {
      const vm = this
      if (vm.selectedList.symbol === 'USDT') {
        return vm.USDTBalance;
      } else if (vm.selectedList.symbol === 'WBNB') {
        return vm.WBNBBalance;
      }
      return '0';
    }

  },
  watch: {
    show: {
      handler() {
        const vm = this
        if (vm.show) {
          vm.hqBalance()
          vm.localTranNum = vm.tranNum;
          // console.log('监听',vm.defaultBalance)
          if (Number(vm.defaultBalance) > 0) {
            // console.log('监听1',vm.defaultBalance)
            // 首次进来是卖出
            vm.isAdd = false
            vm.activeStep = 2;
          }
        }
      }
    }
  },
  methods: {
    handleRecharge(amount) {
      console.log('充值金额:', amount);
      // TODO
      this.$toast(`已成功充值 ${amount} USDT`);
    },
    async hqBalance(type) {
      const vm = this;
      // 代币合约地址
      const USDT_CONTRACT = '0x55d398326f99059fF775485246999027B3197955'; // BSC上的USDT合约地址
      const WBNB_CONTRACT = '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c'; // BSC上的WBNB合约地址

      // 获取 USDT 余额
      const usdtBalance = await threeKingdoms.getTokenBalance(USDT_CONTRACT, vm.accountInfo);
      // USDT 小数位数为 18
      const usdtDecimals = new Decimal(10).pow(18);
      const formattedUsdtBalance = new Decimal(usdtBalance).div(usdtDecimals).toString();
      // 获取 WBNB 余额
      const wbnbBalance = await threeKingdoms.getTokenBalance(WBNB_CONTRACT, vm.accountInfo);
      const wbnbDecimals = new Decimal(10).pow(18);
      const formattedWbnbBalance = new Decimal(wbnbBalance).div(wbnbDecimals).toString();

      console.log('formattedUsdtBalance',formattedUsdtBalance,formattedWbnbBalance)
      vm.USDTBalance = $formatDecimals(formattedUsdtBalance,2)
      vm.WBNBBalance = $formatDecimals(formattedWbnbBalance,2)
      if(type == 1){
        // 将余额存储到 Vuex 中
        vm.$store.commit('USDTBalance', $formatDecimals(formattedUsdtBalance,2));
        vm.$store.commit('WBNBBalance', $formatDecimals(formattedWbnbBalance,2));
      }
    },
    // 点击退出
    async qrClone() {
      const vm = this
      // 使用Vant的确认弹窗
      vm.$dialog.confirm({
        title: '退出自动交易',
        message: '退出后将暂停自动交易',
      })
      .then(() => {
        // 点击确认按钮后关闭弹窗
        vm.closePopup();
      })
    },
    // 关闭弹窗-需要清空各种数据
    async closePopup() {
      const vm = this
      vm.$emit('update:show', false);

      vm.activeStep = 0; // 重置步骤为第一步
      vm.isStart = 0
      vm.currentNum = 0; // 重置当前交易次数
      vm.transactions = []; // 清空交易记录

      await vm.hqBalance(1) //重新获取余额
    },

    // 点击交易
    async clickTxsPar() {
      const vm = this;
      // 如果是继续交易（isStart之前为2），并且activeStep为2，则从卖出步骤开始
      if (vm.isStart == 2 && (vm.activeStep == 2 || vm.activeStep == 3)) {
        vm.isStart = 1
        await vm.clickTxs(2);
      }else{
        if(vm.isAdd == true){
          vm.activeStep = 1;
        }else{
          vm.activeStep = 3;
        }
        vm.isStart = 1
        const isSell = parseFloat(vm.defaultBalance) > 0;
        console.log('currentBalance,defaultBalance', vm.currentBalance, vm.defaultBalance)
        await vm.clickTxs(isSell ? 2 : 1)
      }
    },
    // 点击交易
    async clickTxs(type) {
      const vm = this;
      try {
        // vm.activeStep = type;
        await window.threeKingdoms.init();

        // 买入或卖出逻辑
        if (type === 1) {
          await this.processBuyTrade();
        } else {
          await this.processSellTrade();
        }

      } catch (error) {
        console.error('交易过程中出错:', error);
        if(error.code == 4001){
          vm.$toast({
            message: '交易失败: 用户拒绝交易签名',
            position: 'top',
            duration: 5000
          });
        }else{
          vm.$toast({
            message: '交易失败: ' + (error.message || '未知错误'),
            position: 'top',
            duration: 5000
          });
        }
        vm.isStart = 2; // 设置为暂停状态
      }
    },

    // 处理买入交易
    async processBuyTrade() {
      const vm = this;
      try {
        vm.activeStep = 1;

        // 1. 检查授权
        const allowanceResult = await threeKingdoms.checkTokenAllowance(
            vm.selectedList.address,
            vm.accountInfo,
            vm.selectedList.decimals
        );
        // vm.$toast('检查授权',allowanceResult);
        const tradeAmount = await threeKingdoms.toReal(vm.tradeAmount,vm.selectedList.decimals)
        // console.log('当前买入授权额度',allowanceResult)
        // 2. 如果需要授权
        if (Number(tradeAmount) > Number(allowanceResult)) {
          vm.$toast('授权额度不足，正在进行授权...');
          await threeKingdoms.approveToken(vm.selectedList.address);
          vm.$toast('授权已发送，继续交易...');
        }

        // 3. 执行买入交易
        let cs = 0; // 重试次数
        let createInfo, ygGas;
        const maxRetries = 10; // 最大重试次数

        while (cs <= maxRetries) {
          try {
            createInfo = await vm.requestSign(1, cs);
            // vm.$toast('调用接口获取数据',createInfo);
            if (!createInfo) throw new Error('获取交易数据失败');

            // 3.1 预估gas
            ygGas = await threeKingdoms.estimateAndSend(createInfo);
            if (ygGas) break; // 预估成功，跳出循环
            cs++;
            console.log(`预估gas失败，正在进行第${cs}次重试...`);
          } catch (error) {
            console.error('交易准备过程中出错:', error);
            throw error;
          }
        }


        const txHash = await threeKingdoms.sendTransaction(createInfo);
        // vm.$toast('交易哈希',txHash);
        if (!txHash) throw new Error('发送交易失败');


        // 4. 等待交易确认
        const receipt = await threeKingdoms.waitForTransactionReceipt(txHash);
        if (!receipt.success) throw new Error('交易失败');

        vm.activeStep = 2; // 买入成功

        // 5. 检查是否有余额可卖出
        const defaultBalance = await threeKingdoms.getTokenBalance(vm.defaultPath.address, vm.accountInfo);
        console.log('defaultBalance',defaultBalance)

        if (defaultBalance > 0) {
          vm.activeStep = 3;
          await vm.clickTxs(2);
        }
      } catch (error) {
        console.error('买入交易失败:', error);
        vm.isStart = 2; // 设置为暂停状态
        throw error;
      }
    },

    // 处理卖出交易
    async processSellTrade() {
      const vm = this;
      try {
        vm.activeStep = 3
       // 获取卖出余额
        const defaultBalance = await threeKingdoms.getTokenBalance(vm.defaultPath.address, vm.accountInfo);
        // 1. 检查授权
        const allowanceResult = await threeKingdoms.checkTokenAllowance(
            vm.defaultPath.address,
            vm.accountInfo
        );
        console.log('当前卖出授权额度,需要授权额度',allowanceResult,defaultBalance)
        // 2. 如果需要授权
        if (Number(defaultBalance) > Number(allowanceResult)) {
          vm.$toast('卖出授权额度不足，正在进行授权...');
          await threeKingdoms.approveToken(vm.defaultPath.address);
          vm.$toast('卖出授权已发送，继续交易...');
        }


        // 3. 执行卖出交易
        let cs = 0; // 重试次数
        let createInfo, ygGas;
        const maxRetries = 10; // 最大重试次数

        while (cs <= maxRetries) {
          try {
            createInfo = await vm.requestSign(2, cs);
            if (!createInfo) throw new Error('获取交易数据失败');

            // 3.1 预估gas
            ygGas = await threeKingdoms.estimateAndSend(createInfo);
            if (ygGas) break; // 预估成功，跳出循环

            // 预估失败，增加重试次数
            cs++;
            console.log(`预估gas失败，正在进行第${cs}次重试...`);
          } catch (error) {
            console.error('交易准备过程中出错:', error);
            throw error;
          }
        }

        const txHash = await threeKingdoms.sendTransaction(createInfo);
        if (!txHash) throw new Error('发送交易失败');

        // 4. 等待交易确认
        const receipt = await threeKingdoms.waitForTransactionReceipt(txHash);
        if (!receipt.success) throw new Error('卖出交易失败');

        vm.activeStep = 4;

       // 5. 更新交易计数 - 只有在非首次卖出时才增加计数
        if (vm.isAdd) {
          vm.currentNum++;
        } else {
          // 首次卖出，将isAdd设置为true，后续卖出将增加计数
          vm.isAdd = true;
        }

        // 6. 检查是否完成所有交易
        if (vm.currentNum >= vm.localTranNum) {
          vm.wcShow = true
          vm.isStart = 3
          return;
        }

        // 7. 继续下一轮交易
        await vm.hqBalance();
        // const adjustedAmount = Math.min(Number(vm.tradeAmount), vm.currentBalance);
        //
        // if (adjustedAmount !== Number(vm.tradeAmount)) {
        //   vm.$emit('update:tradeAmount', adjustedAmount.toString());
        // }
        if(Number(vm.tradeAmount) > Number(vm.USDTBalance)){
          vm.tradeAmount = vm.USDTBalance
          vm.$emit('update:tradeAmount', vm.USDTBalance.toString());
        }
        await vm.clickTxs(1);
      } catch (error) {
        console.error('卖出交易失败:', error);
        vm.isStart = 2; // 设置为暂停状态
        throw error;
      }
    },
    // 发送交易请求
    async requestSign(type,cs) {
      const vm = this
      vm.$axios.defaults.withCredentials = false;
      const defaultBalance = await threeKingdoms.getTokenBalance(vm.defaultPath.address, vm.accountInfo);
      // 卖出
      let params = {
        "userAddress": vm.accountInfo,
        "fromToken": vm.defaultPath.address,
        "fromTokenAmount": defaultBalance,
        "toToken": vm.selectedList.address,
        "retryTimes": cs
      }
      if (type == 1) {
        // 买入
        params = {
          "userAddress": vm.accountInfo,
          "fromToken": vm.selectedList.address,
          "fromTokenAmount": vm.tradeAmount,
          "toToken": vm.defaultPath.address,
          "retryTimes": cs
        }
      }
      let url = '/alpha/txs/create/sell'
      if (type == 1) {
        url = '/alpha/txs/create/buy'
      }
      try {
        const response = await vm.$axios.post(url, params);
        const {success, msg, data,code} = response.data;
        if (!success) {
          vm.$message.error(msg || '请求数据失败');
          return null;
        }
        return data.rawTx;
      } catch (error) {
        vm.isStart = 2
        // console.error('请求买入交易数据失败111:', error);
        // 检查是否有响应数据
        if (error.response && error.response.data) {
          // 从响应数据中获取错误代码
          const errorCode = error.response.data.code;
          if (errorCode === 1022 || errorCode === '1022') {
            vm.balanceTipShow = true;
          }
        }
        return null;
      }
    },
  }
};
</script>